module.exports = __webpack_public_path__ + "img/words.acb03281.png";